module.exports = __webpack_public_path__ + "exr-wrap.js";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader/dist/cjs.js?name=exr-wrap.js!./build_npm/exr-wrap/exr-wrap.js
// module id = 1
// module chunks = 0